export const ru = {
    cancel: 'Отмена',
    'check-all': 'Выбрать все ({total})',
    copy: 'Скопировать',
    crop: 'Обрезать заново',
    'filtered-items': 'Отфильтровано: {filteredOut}',
    'item-id': 'ID: {id}',
    'item-size': '{width}x{height}',
    submit: 'Выбрать размеры',
    title: 'Размеры группы «{creativeName}»'
};
